module.exports = __webpack_public_path__ + "static/media/m-vermipro.d17df39d.pdf";